/**
 * Created by matheusmorett on 05/09/18.
 */
import React, { Component } from 'react';
import "./Ribbon.scss";

export default class Ribbon extends Component {

    render() {
        return (
            <div className="Ribbon">
                {this.props.children}
            </div>
        )
    }

}

